import {NotificationInteraction, type NotificationInteractionData} from "@/types/site_admin/notificationInteraction";

export class Release {
    public id: number | null;
    public client_title: string;
    public self_service_title: string;
    public client_text: string;
    public self_service_text: string;
    public client_short_description: string;
    public self_service_short_description: string;
    public set_release_client: number;
    public set_release_self_service: number;
    public client_release_enabled: boolean;
    public self_service_release_enabled: boolean;
    public client_release_date: Date | null;
    public self_service_release_date: Date | null;
    public client_from: Date | null;
    public self_service_from: Date | null;
    public client_until: Date | null;
    public self_service_until: Date | null;
    public service: string;
    public notificationInteractions: NotificationInteraction[];

    constructor(data: ReleaseData | void) {
        if (data === undefined) {
            this.id = null;
            this.client_title = "";
            this.self_service_title = "";
            this.client_text = "";
            this.self_service_text = "";
            this.client_short_description = "";
            this.self_service_short_description = "";
            this.set_release_client = 0;
            this.set_release_self_service = 0;
            this.client_release_enabled = false;
            this.self_service_release_enabled = false;
            this.client_release_date = null;
            this.self_service_release_date = null;
            this.client_from = null;
            this.self_service_from = null;
            this.client_until = null;
            this.self_service_until = null;
            this.service = "";
            this.notificationInteractions = [];
        } else {
            this.id = data.id;
            this.client_title = data.client_title;
            this.self_service_title = data.self_service_title;
            this.client_text = data.client_text;
            this.self_service_text = data.self_service_text;
            this.client_short_description = data.client_short_description;
            this.self_service_short_description = data.self_service_short_description;
            this.set_release_client = data.set_release_client;
            this.set_release_self_service = data.set_release_self_service;
            this.client_release_enabled = data.client_release_enabled;
            this.self_service_release_enabled = data.self_service_release_enabled;
            this.client_release_date = null;
            if (data.client_release_date !== null) {
                this.client_release_date = new Date(data.client_release_date);
            }
            this.self_service_release_date = null;
            if (data.self_service_release_date !== null) {
                this.self_service_release_date = new Date(data.self_service_release_date);
            }
            this.client_from = null;
            if (data.client_from !== null) {
                this.client_from = new Date(data.client_from);
            }
            this.self_service_from = null;
            if (data.self_service_from !== null) {
                this.self_service_from = new Date(data.self_service_from);
            }
            this.client_until = null;
            if (data.client_until !== null) {
                this.client_until = new Date(data.client_until);
            }
            this.self_service_until = null;
            if (data.self_service_until !== null) {
                this.self_service_until = new Date(data.self_service_until);
            }
            this.service = data.service;
            this.notificationInteractions = [];
            if (data.notificationInteractions !== undefined) {
                data.notificationInteractions.forEach(notificationInteraction => this.notificationInteractions.push((new NotificationInteraction(notificationInteraction))));
            }
        }
    }

    serializeData(without_relations: boolean | Array<string> = false) {
        const serialized_data = {
            id: this.id,
            client_title: this.client_title,
            self_service_title: this.self_service_title,
            client_text: this.client_text,
            self_service_text: this.self_service_text,
            client_short_description: this.client_short_description,
            self_service_short_description: this.self_service_short_description,
            set_release_client: this.set_release_client,
            set_release_self_service: this.set_release_self_service,
            client_release_enabled: this.client_release_enabled,
            self_service_release_enabled: this.self_service_release_enabled,
            client_release_date: this.client_release_date,
            self_service_release_date: this.self_service_release_date,
            client_from: this.client_from,
            self_service_from: this.self_service_from,
            client_until: this.client_until,
            self_service_until: this.self_service_until,
            service: this.service,
        }
        if (without_relations === false ||
            (
                Array.isArray(without_relations) &&
                !without_relations.includes('notificationInteractions')
            )
        ) {
            serialized_data.notificationInteractions = [];
            this.notificationInteractions.forEach(el => {
                serialized_data.notificationInteractions.push(el.serializeData())
            })
        }

        return serialized_data;
    }

    public resetToDefaults(): void {
        this.id = null;
        this.client_title = "";
        this.self_service_title = "";
        this.client_text = "";
        this.self_service_text = "";
        this.client_short_description = "";
        this.self_service_short_description = "";
        this.set_release_client = 0;
        this.set_release_self_service = 0;
        this.client_release_enabled = false;
        this.self_service_release_enabled = false;
        this.client_release_date = null;
        this.self_service_release_date = null;
        this.client_until = null;
        this.self_service_from = null;
        this.client_from = null;
        this.self_service_until = null;
        this.service = "";
    }
}

export type ReleaseData = {
    id: number | null;
    client_title: string;
    self_service_title: string;
    client_text: string;
    self_service_text: string;
    client_short_description: string;
    self_service_short_description: string;
    set_release_client: number;
    set_release_self_service: number;
    client_release_enabled: boolean;
    self_service_release_enabled: boolean;
    client_release_date: Date | null;
    self_service_release_date: Date | null;
    client_from: Date | null;
    self_service_from: Date | null;
    client_until: Date | null;
    self_service_until: Date | null;
    service: string;
    notificationInteractions: NotificationInteractionData[];
}
